export default __webpack_public_path__ + "static/media/Emanuele Trevi .77a49668.jpg";